export const notionList = [
  {
    image: 'images/page_react.png',
    title: '[React] 컴포넌트 기반의 자바스크립트 UI 라이브러리, 리액트 총정리',
    url: 'https://imjone.notion.site/React-c516a764ebee4d8e898d714a85d9475b',
  },
  {
    image: 'images/page_ts.jpg',
    title: '[TS] 타입스크립트의 강력한 타입 시스템과 객체 지향 프로그래밍',
    url: 'https://imjone.notion.site/TypeScript-7176d1d3d64f467bb6c819b5e9ad5e72',
  },
  {
    image: 'images/page_js.png',
    title: '[JS] 자바스크립트 ES6+ 기본 문법 및 내부 구현 사항 총정리',
    url: 'https://imjone.notion.site/JavaScript-5fc08fb5d6bd4bef838e275d4d924f4b',
  },
  {
    image: 'images/page_git.png',
    title: '[Git] 버전 관리 시스템을 사용하는 이유 / Git 명령어 모음',
    url: 'https://imjone.notion.site/Git-fdf84d8e4e224853bac94b8886d8a373',
  },
  {
    image: 'images/page_project.png',
    title: '[Project] 프로젝트 소스 코드 및 회고록',
    url: 'https://imjone.notion.site/3fe849b68fa948219b7265fa0fcd479c?v=fe57bbe9842f44909bd6a5afb68ae2d4',
  },
  {
    image: 'images/page_error.png',
    title: '[Error Note] 에러 노트 정리',
    url: 'https://imjone.notion.site/Error-Note-7d12a9a9e92c47be8c31318ebe58a01f',
  },
];
